"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.page.login_page': 'Logowanie',
    'app.page.registration_page': 'Rejestracja',
};
